import React from 'react';

export default function Money() {
	return (
		<g>
			<polygon fill="#66AA88" points="151.44595,368.28943 151.44595,400.67505 64.84555,413.52036 34.79037,394.89786
				34.78257,362.99457 64.83562,381.02542" />
			<path fill="#5F9B7B" d="M64.84555,391.2417l12.36633-1.79156c0.36752-0.09317,3.84599-0.47253,3.7525-0.84006
				c-0.08172-0.32156-3.63493-0.526-3.95404-0.5108l-12.16479-0.76062V391.2417z" />
			<path fill="#5F9B7B" d="M83.14124,394.42902l-18.29569,1.05804v4.61221l18.49722-4.31943
				c0.36891-0.08319,3.85659-0.85547,3.77306-1.22433C87.04027,394.22034,83.474,394.40393,83.14124,394.42902z" />
			<path fill="#5F9B7B" d="M139.17935,377.43527l12.2666-3.12384v3.88879l-12.06506,0.58588
				c-0.31911,0.01553-4.6835,0.32272-4.76523,0.00079C134.52219,378.41974,138.81184,377.52875,139.17935,377.43527z" />
			<path fill="#5F9B7B" d="M133.54004,386.05991l17.90591-4.05905v4.08752l-17.70436,1.32269
				c-0.33276,0.02509-3.18181,0.1442-3.25739-0.19131C130.40067,386.85086,133.17114,386.14343,133.54004,386.05991z" />
			<polygon fill="#71BC96" points="151.44595,368.28943 64.84555,381.22189 34.78427,362.99557 121.38467,350.06311 		" />
			<polygon fill="#91CEAC" points="46.60955,365.37283 120.52516,354.33432 139.62099,365.91238 65.70403,376.95093 		" />
			<path fill="#71BC96" d="M82.24339,355.90826c10.4115-1.55478,19.73953,3.0842,23.69209,6.19632
				c3.95255,3.11212,10.055,11.47958,0.32608,12.93246c-9.72892,1.45285-20.26849-4.07117-24.76002-7.84406
				S74.89825,357.00516,82.24339,355.90826z" />
			<path fill="#71BC96" d="M65.53941,365.7453c3.44715-0.51477,6.53558,1.02115,7.84423,2.05154
				c1.30865,1.0304,3.32912,3.80078,0.10796,4.2818c-3.22115,0.48105-6.71071-1.3479-8.19781-2.59708
				C63.80668,368.23239,63.10749,366.10846,65.53941,365.7453z" />
			<path fill="#71BC96" d="M113.87035,358.51193c3.44714-0.51477,6.53558,1.02115,7.84422,2.05154
				c1.30865,1.0304,3.32912,3.80078,0.10796,4.2818c-3.22115,0.48105-6.71071-1.3479-8.19781-2.59708
				C112.13763,360.99902,111.43844,358.87509,113.87035,358.51193z" />
			<path fill="#91CEAC" d="M86.73431,359.09061c6.55703-1.20206,12.93575,3.01398,12.93575,3.01398l-2.16915,0.89099
				c0,0,5.78441,3.24649,2.16915,3.96954s8.09585,3.70441,8.09585,3.70441l-11.18786,1.59796l-2.12424-3.13312
				C89.02762,369.168,78.20032,360.65509,86.73431,359.09061z" />
			<polygon fill="#5F9B7B" points="64.84555,381.22189 64.84555,413.65945 34.79037,395.03696 34.78427,362.99557 		" />
			<path fill="#EBEFFF" d="M110.18053,380.86002c-9.24514,0-16.73971,3.26328-16.73971,7.28928v7.289v7.289v15.29541
				c0,4.02573,7.49457,7.289,16.73971,7.289s16.73971-3.26328,16.73971-7.289v-15.29541v-7.289v-7.289
				C126.92024,384.12329,119.42567,380.86002,110.18053,380.86002z" />
			<rect x="93.44084" y="388.14911" fill="#DCE4FF" width="10.62132" height="29.31278" />
			<ellipse fill="#F8FAFF" cx="110.18053" cy="388.3652" rx="16.73972" ry="7.28908" />
			<path fill="#EBEFFF" d="M132.59955,415.09827c-9.24514,0-16.73971,3.26358-16.73971,7.289v7.28931
				c0,4.0257,7.49457,7.289,16.73971,7.289s16.7397-3.26331,16.7397-7.289v-7.28931
				C149.33925,418.36185,141.84468,415.09827,132.59955,415.09827z" />
			<path fill="#DCE4FF" d="M115.85979,422.38715v7.28955c0,3.08423,4.40601,5.71484,10.62122,6.7793v-20.35693h-2.31812
				C119.20158,417.3642,115.85979,419.70306,115.85979,422.38715z" />
			<ellipse fill="#F8FAFF" cx="132.59953" cy="422.38742" rx="16.73972" ry="7.28908" />
			<path fill="#EBEFFF" d="M137.60355,405.80737c-9.24515,0-16.73971,3.26358-16.73971,7.289v7.28928
				c0,4.02573,7.49456,7.289,16.73971,7.289c9.24513,0,16.7397-3.26328,16.7397-7.289v-7.28928
				C154.34325,409.07095,146.84868,405.80737,137.60355,405.80737z" />
			<path fill="#DCE4FF" d="M120.86378,413.09625v7.28955c0,3.08423,4.40601,5.71484,10.62122,6.7793v-20.35693h-2.31812
				C124.20558,408.0733,120.86378,410.41217,120.86378,413.09625z" />
			<ellipse fill="#F8FAFF" cx="137.60353" cy="413.09653" rx="16.73972" ry="7.28908" />
			<ellipse fill="#F8FAFF" cx="94.11608" cy="422.38742" rx="16.73972" ry="7.28908" />
			<ellipse fill="#F8FAFF" cx="94.11608" cy="415.09811" rx="16.73972" ry="7.28908" />
			<path fill="#EBEFFF" d="M94.11587,400.52023c-9.24512,0-16.73926,3.26361-16.73926,7.289v21.86731
				c0,4.0257,7.49414,7.289,16.73926,7.289s16.73975-3.26331,16.73975-7.289v-21.86731
				C110.85561,403.78384,103.36098,400.52023,94.11587,400.52023z" />
			<path fill="#DCE4FF" d="M85.67934,401.52103c-4.96143,1.26514-8.30322,3.604-8.30322,6.28809v21.86755
				c0,3.08423,4.40625,5.71484,10.62158,6.7793v-34.93494H85.67934z" />
			<ellipse fill="#F8FAFF" cx="94.11607" cy="407.80942" rx="16.73972" ry="7.28908" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Money.js